import React from "react";

/** LaborEducation.org globe — One World, One Movement design (with power fist). */
export default function SpinningGlobe({ size = "w-16 h-16", alt = "LaborEducation.org — One World, One Movement" }) {
  return (
    <span className={`relative block ${size}`}>
      <img src="/globe-owom-640.png" alt={alt} className="w-full h-full object-contain rounded-xl" />
    </span>
  );
}
